import { Component, OnInit,Input } from '@angular/core';
import { Title,Meta } from "@angular/platform-browser";
@Component({
  selector: 'app-mmetatag',
  templateUrl: './mmetatag.component.html',
  styleUrls: ['./mmetatag.component.css'],
  providers:[Title,Meta],
})
export class MmetatagComponent implements OnInit {
  @Input() public page;
  constructor(private titleService: Title,private meta: Meta) {
    
   }

  ngOnInit() {
    this.titleService.setTitle(this.page.title);
    this.meta.updateTag({ name: 'description', content: this.page.desciprtion });
    this.meta.updateTag({ name: 'keywords', content: this.page.keywords });
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/mmetatag/mmetatag.component.ts